import api from '~/services/api';

function getFaqService() {
  return api.get('faq');
}

export { getFaqService };
